export default "__VITE_ASSET__eb475512__"